import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { Color, Tile, TILE_TOKEN, TileId, TileType, TRANSLATION_NS } from '@contact/upgrade';

@NgModule({})
export class ResponderForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: ResponderForRootModule) {
    if (parentModule) throw new Error(`[ResponderForRootModule] module is already loaded`);
  }

  static instance(options: { path: string }): ModuleWithProviders<ResponderForRootModule> {
    return {
      ngModule: ResponderForRootModule,
      providers: [
        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.RESPONDER,
            type: TileType.STANDARD,
            icon: 'call',
            color: Color.FUCHSIA,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
            activePlatform: 'desktop',
          } as Tile,
          multi: true,
        },
        {
          provide: TRANSLATION_NS,
          useValue: 'responder',
          multi: true,
        },
      ],
    };
  }
}
